import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { queryClient } from "../lib/queryClient";
import { meQuery } from "../hooks/useAuth";
import { ApiError } from "../lib/api";
import { Shell } from "../components/layout/Shell";
import { ToastHost, ToastProvider } from "../components/ui/Toast";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ location }) => {
    try {
      await queryClient.ensureQueryData(meQuery);
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        throw redirect({ to: "/login", search: { next: location.href } });
      }
      throw err;
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <ToastProvider>
      <Shell>
        <Outlet />
      </Shell>
      <ToastHost />
    </ToastProvider>
  );
}
